import _define_property from "@swc/helpers/src/_define_property.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import LazyImage from "./LazyImage";
import AspectRatioBox from "../layout/AspectRatioBox";
import { IMAGE_FORMATS } from "./imageFormats";
import isContentfulAsset from "../../utils/isContentfulAsset";
var Image = function(_param) {
    var width = _param.width, height = _param.height, src = _param.src, props = _object_without_properties(_param, [
        "width",
        "height",
        "src"
    ]);
    var extension = src.split(".").pop() || "";
    if (extension) {
        extension = extension.split("?")[0].split("#")[0];
    }
    var imageType = IMAGE_FORMATS[extension] ? extension : "*";
    var placeholder;
    var original = _define_property({}, imageType, src);
    // TODO: add possibility to pass placeholder in props
    if (width && height && isContentfulAsset(src)) {
        var placeholderWidth = Math.floor(width / 20);
        var placeholderHeight = Math.floor(height / 20);
        placeholder = _define_property({}, imageType, "".concat(src, "?w=").concat(placeholderWidth, "&h=").concat(placeholderHeight));
        if (extension !== "svg") {
            original.webp = "".concat(src, "?fm=webp&q=65");
            placeholder.webp = "".concat(src, "?fm=webp&w=").concat(placeholderWidth, "&h=").concat(placeholderHeight, "&q=65");
        }
    }
    return width && height ? /*#__PURE__*/ _jsx(AspectRatioBox, {
        $width: width,
        $height: height,
        children: /*#__PURE__*/ _jsx(LazyImage, _object_spread({
            width: width,
            height: height,
            original: original,
            placeholder: placeholder
        }, props))
    }) : /*#__PURE__*/ _jsx(LazyImage, _object_spread({
        original: original,
        placeholder: placeholder
    }, props));
};
export default Image;
